export default __webpack_public_path__ + "static/media/Level23.568d3bce.svg";